<template>
<!-- 围栏组编辑 -->
  <div class="text-left">
    <Modal v-model="modal"  :mask-closable="false" :closable="false"  class-name="vertical-center-modal" :transfer="false" :title="modalTitle">
        <Form
          ref="formData"
          label-position="right"
          :label-width="100"
          :model="formData"
          :rules="ruleForm"
         >
          <Row>
            <Col>
              <FormItem :label="$t('label_newPassword')" prop="newPassword">
                <Input type="password" :maxlength="50" v-model.trim="formData.password" :placeholder="$t('placeholder_newpassword')" class="step-input"/>
              </FormItem>
            </Col>
            <Col>
              <FormItem :label="$t('label_confirmPassword')" prop="confirmPassword">
                <Input @keydown.native.enter.prevent="handleSubmit('formData')" :maxlength="50" type="password" v-model.trim="formData.confirmPassword" :placeholder="$t('placeholder_confirmpassword')" class="step-input"/>
              </FormItem>
            </Col>
          </Row>
        </Form>
        <div slot="footer" class="demo-drawer-footer">
          <Button type="info" size="large" @click="handleCancel()" class="btn-right">{{$t('btn_cancel')}}</Button>
          
          <Button :loading="loadingBtn" type="info" size="large" @click="handleSubmit('formData')" >{{$t('btn_update')}}</Button>
        </div>
    </Modal>
  </div>
</template>
<script>

export default {
  name: "updatePassword",
  props: {
    username: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    oldPassword: {
      type: String,
      default: ''
    }
  },
  data() {
    const validatePass = (rule,value,callback) =>{
				if(value == ''){
					callback(new Error(this.$t('placeholder_newpassword')))
				}else{
					if(this.formData.confirmPassword !== ''){
						this.$refs.formData.validateField('confirmPassword');
					}
					callback()
				}
			};
			const validatePassCheck = (rule,value,callbakc) => {
				if(value === ''){
					callbakc(new Error(this.$t('placeholder_confirmpassword')))
				}else if(value !== this.formData.password){
					callbakc(new Error(this.$t('msg_twoPasswordEmpty')))
				}else{
					callbakc()
				}
			};
    return {
      modal: false,
      modalTitle:this.$t('title_updatePassword'),//修改密码
      formData: {
        username: "",
        password: "",
        confirmPassword:""
      },
      loadingBtn: false,
      ruleForm: {
                    password: [
						{validator: validatePass, trigger:'blur' }
                    ],
                    confirmPassword: [
						{validator: validatePassCheck, trigger:'blur'}
                    ],
				},
    };
  },
  mounted() {
    this.modal = true
  },
  methods: {
    
      //提交
    handleSubmit(name) {
      let _this = this;
      this.$refs[name].validate((valid) => {
        valid && _this.update();
      })
    },
    update(){
      let _this = this;
      _this.loadingBtn = true;
      
      let params = {
        mac: '',
        username: _this.username,
        oldPwd: _this.oldPassword,
        newPwd: _this.formData.password,
      };
      let url = this.HOSTElock + "user/updateByUsername?locale="+ _this.$comjs.returnLanguageType();
      // {headers: {'Authorization': _this.token}}
      this.$axios.post(url, params).then(res => {
        if(res.data.code == 0) {
            _this.$Message.success(this.$t('msg_updateSuccess'));
            // 关闭窗口
            _this.handleCancel()
        }
        _this.loadingBtn = false;
            
      }).catch(()=>{
        _this.loadingBtn = false;
      });
    },
    // 关闭弹窗
    clearModal() {
      setTimeout(() => {
        this.$emit("clear");
      }, 500);
    },
    // 关闭弹窗
    handleCancel(){
      this.modal = false;
      this.clearModal()
    }
  }
};
</script>

<style >

.ivu-modal-footer{
		border-top: none;
	}
</style>
